<template>
  <div>
    <PageSpinner :onloader="onloader" />
    <router-link to="/login" class="goback-btn" aria-label="Return to home page">
      <span class="goback-icon-wrapper">
        <i class="fa fa-arrow-left"></i>
      </span>
      <span class="goback-label">Login</span>
    </router-link>
    <hr />
    <div class="scrollable-content ">
      <div class="animate__animated animate__slideInDown mb-5">
        <div class="login-header">
          <h1 class="login-title">Register Your School</h1>
          <p class="login-subtitle">Provide your school details to get started</p>
        </div>
        <form role="form" @submit.prevent="submitdata">

        <div v-if="errmsg" class="alert alert-danger text-center">
          <p>{{ errmsg }}</p>
        </div>
        <div class="">
          <div class="form-group">
            <base-input :class="SchoolNamestyle" placeholder="School Name" addon-left-icon="fa fa-minus"
              v-model="SchoolNameval">
            </base-input>
          </div>
          <div class="form-group">
            <base-input :class="ContactPersonstyle" placeholder="Contact Person" addon-left-icon="fa fa-minus"
              v-model="ContactPersonval">
            </base-input>
          </div>
          <div class="form-group">
            <base-input :class="ContactPhoneNostyle" placeholder="Contact Phone No." addon-left-icon="fa fa-phone"
              v-model="ContactPhoneNoval">
            </base-input>
          </div>
          <div class="form-group">
            <base-input :class="ContactEmailstyle" placeholder="Email Address" addon-left-icon="fa fa-envelope"
              v-model="ContactEmailval">
            </base-input>
          </div>
          <div class="form-group">
            <select v-model="StateIdval" :class="StateIdstyle" @change="getlga()">
                <option value="0" selected>- Select State -</option>
                <option v-for="item in stateitems" :key="item.Id" v-bind:value="item.Id">
                  {{ item.StateName }}
                </option>
              </select>
          </div>
          <div class="form-group">
            <select v-model="LgaIdval" :class="LgaIdstyle">
                <option value="0">- Select LGA -</option>
                <option v-for="item in lgaitems" :key="item.Id" v-bind:value="item.Id">
                  {{ item.Local_Govt_Name }}
                </option>
              </select>
          </div>
          <div class="form-group">
           <base-input :class="Citystyle" placeholder="Enter City" addon-left-icon="fa fa-street-view"
                v-model="Cityval">
              </base-input>
          </div>
         <div class="form-group">
              <textarea v-model="Addressval" :class="Addressstyle" class="form-control" placeholder="Enter Address"
                rows="3"></textarea>
            </div>
        </div>
        <div class="text-center my-2">
          <p class="text-xs">
            Submittin this form means you have accepted our
            <router-link to="/privacy" class="text-xs">Privacy Policy</router-link>
          </p>
        </div>
        <div >
          <button type="submit" class="btn login-button" :disabled="$store.state.appdatas.disenableifNotOnline">Submit <i class="fa fa-arrow-right"></i></button>
        </div>

      </form>
     
      </div>
    </div>
  </div>

</template>

<script>
import { mapState } from "vuex";
import Alert from "@/mixins/Alert.mixins"
import PageSpinner from "@/components/PageSpinner";
export default {
  name: "register-school",
  mixins: [Alert],
  components: {
    PageSpinner
  },
  data() {
    return {
      SchoolNameval: "",
      ContactPersonval: "",
      ContactPhoneNoval: "",
      ContactEmailval: "",
      StateIdval: 0,
      LgaIdval: 0,
      Cityval: "",
      Addressval: "",
      lgaitems: null,
      SchoolNamestyle: "input-group-alternative mb-3",
      ContactPersonstyle: "input-group-alternative mb-3",
      ContactPhoneNostyle: "input-group-alternative mb-3",
      ContactEmailstyle: "input-group-alternative mb-3",
      StateIdstyle: "form-control mb-3",
      LgaIdstyle: "form-control mb-3",
      Citystyle: "input-group-alternative mb-3",
      Addressstyle: "input-group-alternative mb-3",
      errmsg: "",
      pwdmsg: "",
      onloader: "none",
    };
  },
  computed: {
    ...mapState({
      stateitems: (state) => state.addressinfo.stateitems,
    }),
  },
  methods: {
    submitdata: function () {
      let msg = "";
      let SchoolName = this.SchoolNameval;
      let ContactPerson = this.ContactPersonval;
      let ContactPhoneNo = this.ContactPhoneNoval;
      let ContactEmail = this.ContactEmailval;
      let StateId = this.StateIdval;
      let LgaId = this.LgaIdval;
      let City = this.Cityval;
      let Address = this.Addressval;
      this.SchoolNamestyle = "input-group-alternative mb-3";
      this.ContactPersonestyle = "input-group-alternative mb-3";
      this.ContactPhoneNostyle = "input-group-alternative mb-3";
      this.ContactEmailstyle = "input-group-alternative mb-3";
      this.StateIdstyle = "form-control mb-3";
      this.LgaIdstyle = "form-control mb-3";
      this.Citystyle = "input-group-alternative mb-3";
      this.Addressstyle = "input-group-alternative mb-3";
      let accesskey = this.$store.state.auth.accesskey;
      if (SchoolName == "" || SchoolName == null) {
        msg = "Enter School Name, ";
        this.SchoolNamestyle = "input-group-alternative mb-3 has-danger";
      }
      if (ContactPerson == "" || ContactPerson == null) {
        msg += "Enter Contact Person, ";
        this.ContactPersonstyle = "input-group-alternative mb-3 has-danger";
      }
      if (ContactPhoneNo == "" || ContactPhoneNo == null) {
        msg += "Enter Contact Phone Number, ";
        this.ContactPhoneNostyle = "input-group-alternative mb-3 has-danger";
      }
      if (ContactEmail == "" || ContactEmail == null) {
        msg += "Enter Contact Email Address, ";
        this.ContactEmailstyle = "input-group-alternative mb-3 has-danger";
      }
      if (StateId < 1) {
        msg += "Select State, ";
        this.StateIdstyle = "form-control mb-3 has-danger";
      }
      if (LgaId < 1) {
        msg += "Select Local Gorvernment, ";
        this.LgaIdstyle = "form-control mb-3 has-danger";
      }
      if (City == "" || City == null) {
        msg += "Enter City ";
        this.Citystyle = "input-group-alternative mb-3 has-danger";
      }
      if (Address == "" || Address == null) {
        msg += "Enter Address ";
        this.Addressstyle = "input-group-alternative mb-3 has-danger";
      }
      if (msg == "") {
        this.onloader = "flex";
        let userdata = {
          SchoolName,
          ContactPerson,
          ContactPhoneNo,
          ContactEmail,
          StateId,
          LgaId,
          City,
          Address,
          accesskey,
        };
        this.$store
          .dispatch("schoolsignup", userdata)
          .then(() => {
            this.ContactPersonval = "";
            this.ContactPhoneNoval = "";
            this.ContactEmailval = "";
            this.StateIdval = 0;
            this.LgaIdval = 0;
            this.Cityval = "";
            this.Addressval = "";
            this.lgaitems = null;
            this.onloader = "none";
            this.$router.push("/login");
            this.ShowAlertSuccess('Submitted Successfully, we will get back to you soon', '');
          })
          .catch((err) => {
            this.onloader = "none";
            this.ShowAlertError(err.response.data, '');
          });
      } else {
        this.errmsg = msg;
        this.ShowAlertError('One or More Input is/are empty', '');
      }
    },
    getlga: function () {
      this.lgaitems = [];
      let StateId = this.StateIdval;
      if (StateId > 0) {
        this.onloader = "flex";
        this.$store
          .dispatch("getlgas", StateId)
          .then((resp) => {
            this.lgaitems = resp;
            this.onloader = "none";
          })
          .catch((err) => {
            this.onloader = "none";
            if (
              err.response.data === "Access Expired" ||
              err.response.data === "Invalid Credential"
            ) {
              this.$store.dispatch("logout");
              this.$router.push("/login");
            } else {
              this.ShowAlertError(err.response.data, '');
            }
          });
      }
    },
  },
};
</script>

<style scoped>
.login-header {
  margin-bottom: 40px;
}

.login-title {
  font-size: 32px;
  font-weight: 700;
  color: #333;
  margin-bottom: 10px;
}

.login-subtitle {
  color: #777;
  font-size: 16px;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #555;
}

.form-input {
  width: 100%;
  padding: 14px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.3s ease;
}

.form-input:focus {
  border-color: #6a11cb;
  box-shadow: 0 0 0 2px rgba(106, 17, 203, 0.2);
  outline: none;
}

.remember-forgot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.remember-me {
  display: flex;
  align-items: center;
  gap: 8px;
}

.forgot-password {
  color: #6a11cb;
  text-decoration: none;
  font-weight: 500;
}

.forgot-password:hover {
  text-decoration: underline;
}

.login-button {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(106, 17, 203, 0.4);
}

.goback-btn {
  position: fixed;
  left: 20px;
  top: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  color: #fff;
  border: 2px solid transparent;
  border-radius: 50px;
  box-shadow: 0 8px 24px rgba(106, 17, 203, 0.3),
    0 2px 8px rgba(37, 117, 252, 0.2);
  text-decoration: none;
  font-weight: 600;
  font-size: 15px;
  letter-spacing: 0.3px;
  z-index: 1200;
  transition: all 0.3s cubic-bezier(0.23, 1, 0.320, 1);
  backdrop-filter: blur(10px);
  animation: slideInDown 0.6s ease-out;
  position: relative;
  overflow: hidden;
}

.goback-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
  z-index: -1;
}

.goback-btn:hover::before {
  left: 100%;
}

.goback-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  transition: all 0.3s ease;
}

.goback-btn:hover .goback-icon-wrapper {
  background: rgba(255, 255, 255, 0.25);
  transform: scale(1.1);
}

.goback-btn i {
  font-size: 14px;
  transition: transform 0.3s ease;
}

.goback-btn:hover i {
  transform: translateX(-3px);
}

.scrollable-content {
  max-height: calc(100vh - 100px);
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 0 15px 40px 15px;
  -webkit-overflow-scrolling: touch;
  touch-action: manipulation;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}

.scrollable-content:hover {
  scrollbar-color: #888 #f1f1f1;
}

.scrollable-content::-webkit-scrollbar {
  width: 8px;
}

.scrollable-content::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 10px;
}

.scrollable-content::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 10px;
  transition: background 0.3s ease;
}

.scrollable-content:hover::-webkit-scrollbar-thumb {
  background: #888;
}

.scrollable-content:hover::-webkit-scrollbar-thumb:hover {
  background: #555;
}

@media (max-width: 768px) {
  .scrollable-content {
    max-height: calc(100vh - 80px);
    padding: 0 12px 50px 12px;
  }
}

.goback-label {
  display: inline-block;
  transition: opacity 0.3s ease;
}

.goback-btn:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(106, 17, 203, 0.4),
    0 4px 12px rgba(37, 117, 252, 0.3);
  border-color: rgba(255, 255, 255, 0.2);
}

.goback-btn:active {
  transform: translateY(-2px);
}

.goback-btn:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.5);
  outline-offset: 2px;
}

@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 480px) {
  .goback-btn {
    left: 12px;
    top: 12px;
    padding: 10px 14px;
    gap: 6px;
  }

  .goback-label {
    display: none;
  }

  .goback-icon-wrapper {
    width: 24px;
    height: 24px;
  }

  .goback-btn i {
    font-size: 16px;
  }
}
</style>
